<template>
    <div id="app">
        <keep-alive>
            <!-- 需要缓存的视图组件 -->
            <router-view v-if="$route?.meta?.keepAlive"></router-view>
        </keep-alive>
        <!-- 不需要缓存的视图组件 -->
        <router-view v-if="!$route?.meta?.keepAlive"></router-view>
        <download ref="download" />
    </div>
</template>

<script lang="ts">
import { Component } from 'vue-property-decorator'

import BaseComponent from '@/BaseComponent'
import Download from '@/components/download/index.vue'

/**
 *
 * @author
 * @create 2021-11-23 (星期二)
 */
@Component({ name: 'App', components: { Download } })
export default class extends BaseComponent {
    /* props, data, getter */
    get download(): Download {
        return this.$refs.download as any
    }
    /* life event: [mounted, beforeDestory] */
    /* methods */
}
</script>

<style lang="less" scoped>
#app {
    max-width: 7.5rem;
    margin: auto;
    font-size: 0;
    position: relative;
    font-family: sans-serif;
    color: #333;
}
</style>
